/**
 * Groups entries by workoutId while preserving first-seen workout order
 * and entry order within each group.
 */
export function groupEntriesByWorkout(entries) {
    const groupMap = new Map();
    const orderedKeys = [];
    for (const entry of entries) {
        const existing = groupMap.get(entry.workoutId);
        if (existing) {
            existing.entries.push(entry);
            continue;
        }
        groupMap.set(entry.workoutId, {
            workoutId: entry.workoutId,
            workoutName: entry.workoutName,
            entries: [entry],
        });
        orderedKeys.push(entry.workoutId);
    }
    return orderedKeys.reduce((result, key) => {
        const group = groupMap.get(key);
        if (group) {
            result.push(group);
        }
        return result;
    }, []);
}
//# sourceMappingURL=group-entries-by-workout.js.map